module.exports = __webpack_public_path__ + "static/media/User.70645282.svg";